import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertModel } from '@ose/models';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alert$ = new Subject<AlertModel>();
  private toasts: AlertModel[] = [];

  showAlert(alert: AlertModel): void {
    this.alert$.next(alert);
  }

  showToast(toast: AlertModel, name?: string, single?: boolean): void {
    toast.name = name;
    if (single && this.toasts.some(x => x.name === name)) {
      return;
    }
    const toastElement = document.createElement('div');
    const toastTitleElement = document.createElement('span');
    const toastBodyElement = document.createElement('div');
    const body = document.createElement('span');

    toastElement.classList.add('toast', `t-${name}`, `toast-${toast.type}`);
    toastBodyElement.classList.add('toast-body');

    if (toast.title) {
      toastTitleElement.innerText = toast.title;
    }
    body.innerHTML = toast.body;

    toastBodyElement.append(toastTitleElement, body);
    toastElement.append(toastBodyElement);

    toastElement.style.top = '20px';
    document.body.append(toastElement);
    for (let index = 0; index < this.toasts.length; index++) {
      const element = document.querySelectorAll('.toast')[index] as HTMLElement;
      const elementTop = parseInt(element.style.top.replace('px', ''), 10);
      element.style.top = 15 + elementTop + toastElement.clientHeight + 'px';
    }

    this.toasts.push(toast);

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    if (!toast.static) {
      timeoutId = setTimeout(() => {
        this.deleteAlert(toastElement);
      }, 5000);
    }

    toastElement.addEventListener('click', (e) => {
      const currentTarget = e.currentTarget as HTMLElement;
      this.deleteAlert(currentTarget);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    });
  }

  getAlert(): Observable<AlertModel> {
    return this.alert$.asObservable();
  }

  deleteAlert(toastElement: HTMLElement): void {
    this.removeToastAndReposition(toastElement);
  }

  deleteByName(name: string): void {
    const toastElement = document.querySelector(`body > .toast.t-${name}`) as HTMLElement | null;
    if (toastElement) {
      this.removeToastAndReposition(toastElement);
    }
  }

  private removeToastAndReposition(toastElement: HTMLElement): void {
    const elements = document.querySelectorAll('body > .toast');
    const elementIndex = Array.from(elements).indexOf(toastElement);

    if (elementIndex === -1) return;

    const clientHeight = toastElement.clientHeight;
    toastElement.remove();
    this.toasts.splice(elementIndex, 1);

    for (let i = elementIndex; i >= 0; i--) {
      const element = elements[i] as HTMLElement;
      const elementTop = parseInt(element.style.top.replace('px', ''), 10);
      element.style.top = (elementTop - clientHeight - 15) + 'px';
    }
  }
}
